import React, { Fragment, useCallback } from 'react'
import { SUI, BoxHeadline, Header, Button } from 'shared/ui'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_CANNED_REPLIES_UPDATE } from 'ducks/drawers/types'
import styles from './styles.less'

export default function NoCannedReplies({ onClick, isEmptyAccount }) {
  const { openDrawer: openCreateDrawer } = useDrawer({
    type: DRAWER_TYPE_CANNED_REPLIES_UPDATE,
  })

  const handleOnCreate = useCallback(
    () => {
      openCreateDrawer('new')
      if (onClick) onClick()
    },
    [openCreateDrawer, onClick]
  )

  return (
    <div className={styles.cannedReplyEmpty}>
      <SUI>
        {isEmptyAccount && (
          <Fragment>
            <Header as="div" size="small" className="header" fontWeight="bold">
              {app.t('Canned_replies')}
            </Header>
            <BoxHeadline as="div" color="light" className="body">
              {app.t('Canned_Replies')} let you save commonly used responses
              that you can add them to your conversation in just a few clicks.<br />{' '}
              Creating them takes just a few minutes, and saves you hours in the
              future.
            </BoxHeadline>
          </Fragment>
        )}
        {!isEmptyAccount && (
          <BoxHeadline as="div" color="light" className="body spaced">
            No {app.t('canned_replies')} found
          </BoxHeadline>
        )}
        <Button size="small" primary onClick={handleOnCreate}>
          Create {app.t('canned_reply')}
        </Button>
      </SUI>
    </div>
  )
}
